import { workspaceName } from './gen/ai/h2o/workspace/v1/workspace_pb';

export const workspaceIdFromName = (maybeWorkspaceName: string | undefined): string | undefined => {
  if (!maybeWorkspaceName) return undefined;
  try {
    return workspaceName.parse(maybeWorkspaceName).workspace;
  } catch {
    return undefined;
  }
};
